import Grid from '@mui/material/Grid';

import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import { ContentStyle, TextAlignment } from '@/contentful/contentful.types';
import type {
  Contentful,
  FeaturedComponent,
} from '@/contentful/contentful-exports';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './HighlightText.styles';

export interface HighlightTextContent extends Contentful {
  fields: {
    id: string;
    style?: ContentStyle;
    textAlignment?: TextAlignment.Left | TextAlignment.Center;
    eyebrow?: string;
    headline?: string;
  };
}

type HighlightTextProps = FeaturedComponent<{
  content: HighlightTextContent;
}>;

export default function HighlightText({
  isFeatured,
  content: {
    fields: { id, style, textAlignment, eyebrow, headline },
  },
}: HighlightTextProps) {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes, cx } = useStyles({ isOnDark });
  const { classes: globalClasses } = useGlobalStyles({ fixed: false });

  const isLeftAligned = textAlignment === TextAlignment.Left;
  const gridSizes = isLeftAligned
    ? { lg: 7, md: 6, sm: 12, xs: 12 }
    : { lg: 10, md: 10, sm: 12, xs: 12 };
  const gridOffsets = isLeftAligned
    ? { lg: 0, md: 0, sm: 0, xs: 0 }
    : { lg: 1, md: 1, sm: 0, xs: 0 };

  return (
    <SpacingContainer className={classes.container} isFeatured={isFeatured}>
      <GridContainer fixed wrapperProps={{ id }}>
        <Grid size={gridSizes} offset={gridOffsets}>
          {eyebrow && (
            <div
              className={cx(globalClasses.eyebrow, classes.eyebrow, {
                [classes.textCenter]: textAlignment === TextAlignment.Center,
              })}
            >
              {eyebrow}
            </div>
          )}
          {headline && (
            <div
              className={cx(globalClasses.h1, classes.headline, {
                [classes.textCenter]: textAlignment === TextAlignment.Center,
              })}
            >
              {headline}
            </div>
          )}
        </Grid>
      </GridContainer>
    </SpacingContainer>
  );
}
